import React from "react";
import strings from "../../../utils/property-file/broadcast.json";
import "../broadcast.css";
import BackIcon from "../../../Asset/Images/back-arrow.svg";
import "./broadcastDetails.css";
import BellIcon from "../../../Asset/Images/bell-icon.svg";
import WriteIcon from "../../../Asset/Images/write-icon.svg";
import SingleCheck from "../../../Asset/Images/single-check-icon.svg";
import ReadIcon from "../../../Asset/Images/read-icon.svg";
import { useNavigate } from "react-router-dom";
import constants from "../../../utils/constants";
import api from "../../../services/api";
import { useEffect, useState } from "react";
import moment from "moment";
import BroadcastImageModal from "./BroadcastImageModal";
import SpinnerButton from "../../button/spinnerButton";
import { toast } from "react-toastify";

export default function BroadcastDetails() {
  const broadcasterName = localStorage.getItem("broadcasterName");
  const broadcasterId = localStorage.getItem("broadcastId");
  const [broadcastDetail, setBroadcastDetails] = useState([]);
  const [openImage, setNewOpenImage] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [setImage, setNewImage] = useState("");
  const [fetchingDetails, setFetchingDetails] = useState(true);
  const nav = useNavigate();


  // Here we fetching the details of created broadcast in the params pass the broadcast id 
  
  const fetchBroadcastDetails = async () => {
    try {
      const response = await api.getBroadcastDetails(broadcasterId);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setBroadcastDetails(data.body);
        } else {
          setBroadcastDetails([]);
        }
        setFetchingDetails(false);
      }
    } catch (error) {
      toast.error(strings.somethingWentWrong, { toastId: strings.errorCode });
      setFetchingDetails(false);
    }
  };

  useEffect(() => {
    fetchBroadcastDetails();
  }, []);

  return (
    <>
      <div className="main-container-of-broadcast">
        {fetchingDetails ? (
          <div className="loader-for-broadcast">
            <SpinnerButton />
          </div>
        ) : (
          <>
            {broadcastDetail.length > 0
              ? broadcastDetail.map((key, index) => {
                  return (
                    <div
                      className="sub-container-of-broadcast history-of-broadcast"
                      key={index}
                    >
                      <div className="header-of-broadcast-details">
                        <div className="back-from-broadcast-details">
                          <div
                            className="back-from-broadcast-details-img"
                            onClick={() => {
                              nav(constants.navigationLink.broadcast);
                            }}
                          >
                            <img src={BackIcon} alt="back-icon" />
                          </div>
                          <div className="broadcast-details-title">
                            {key.title}
                          </div>
                        </div>
                        <div className="broadcast-creation-details">
                          <div className="type-of-broadcast">
                            <img src={BellIcon} alt="bell-icon" />
                          </div>
                          <div>{key.type}</div>
                          <div className="divider-of-details-broadcast"></div>
                          <div className="sender-of-broadcast">
                            <img src={WriteIcon} alt="bell-icon" />
                          </div>
                          <div>{broadcasterName}</div>
                          <div className="divider-of-details-broadcast"></div>
                          <div className="sender-of-broadcast">
                            {moment(key.createdDate).format("HH:mm")}
                          </div>
                        </div>
                      </div>
                      <div className="broadcast-content-heading mb-2">
                       {strings.broadcastContent}
                      </div>
                      <div className="details-of-broadcast">
                        <div className="content-of-broadcast">
                          {key.content}
                        </div>
                        <div></div>
                        <div className="name-of-broadcast-receiver">
                          {key.sentToData.length > 0
                            ? key.sentToData.map((newKeyName, newKeyIndex) => {
                                return (
                                        <div key={newKeyIndex} className="read-status-broadcast">
                                          <img
                                            src={newKeyName.isRead ? ReadIcon : SingleCheck}
                                            alt="check-icon"
                                            className="receive-icon"
                                          />
                                          <div className="receiver-broadcast-status">
                                            <div>{newKeyName.name}</div>
                                            {key.type === strings.email || key.type === strings.appEmail ? <div className="broadcast-receiver-email">
                                              {newKeyName.email}
                                            </div> : null}
                                          </div>
                                        </div>
                                );
                              })
                            : null}
                        </div>
                        {key.image.length > 0
                          ? key.image.map((newKey, newIndex) => {
                              return (
                                <div
                                  className="images-of-broadcast-receiver"
                                  key={newIndex}
                                  onClick={() => {
                                    setNewOpenImage(true);
                                    setModalShow(true);
                                    setNewImage(newKey);
                                  }}
                                >
                                  <img src={newKey} alt="images" />
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </div>
                  );
                })
              : null}
          </>
        )}
      </div>
      <div>
        {openImage && (
          <BroadcastImageModal
            image={setImage}
            show={modalShow}
            onHide={() => setModalShow(false)}
          />
        )}
      </div>
    </>
  );
}
